export default "__VITE_ASSET__CNwMBkuw__"